import { render, staticRenderFns } from "./DoKoRestrictionSolo.vue?vue&type=template&id=11dc35b7&scoped=true&"
import script from "./DoKoRestrictionSolo.vue?vue&type=script&lang=ts&"
export * from "./DoKoRestrictionSolo.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoRestrictionSolo.vue?vue&type=style&index=0&id=11dc35b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dc35b7",
  null
  
)

export default component.exports